import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
} from "@/utils/type-vaildator";
import api from "./api";

type AudioTTSStatus = "processing" | "completed" | "failed";

interface AudioTTSResultResponse {
  status: AudioTTSStatus;
  file_url?: string;
}

interface AudioTTSResultRequest {
  taskId: string;
}

export class AudioTTSResultData {
  @Required("Status cannot be empty")
  @IsString("Status must be a string")
  status: AudioTTSStatus;

  @IsString("File URL must be a string")
  fileUrl?: string;
}

const transformAndValidateAudioTTSResult = (
  response: AudioTTSResultResponse
): AudioTTSResultData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AudioTTSResultData);
  } catch (error) {
    console.error("Audio TTS result data validation failed:", error.message);
    throw error;
  }
};

// 获取音频TTS任务结果
export const audioTTSResult = async ({
  taskId,
}: AudioTTSResultRequest): Promise<AudioTTSResultData> => {
  const response = await api.get<AudioTTSResultResponse>(`/audio/tts/result/${taskId}`);
  return transformAndValidateAudioTTSResult(response.data);
};
